// CSS transform for a slide object drawn at `width` x `height` pixels with
// its transform origin at the top-left corner (the editor's default origin).
// Fabric flips an object within its own box, while CSS flips around the
// origin, so a flipped element is shifted back by its own size.
export const getObjectTransform = (
  object: any,
  width: number,
  height: number,
) => {
  const parts = [`rotate(${object.angle || 0}deg)`];
  if (object.flipX) parts.push(`translateX(${width}px)`, 'scaleX(-1)');
  if (object.flipY) parts.push(`translateY(${height}px)`, 'scaleY(-1)');
  return parts.join(' ');
};

export const getObjectOpacity = (object: any) => String(object.opacity ?? 1);

// Fabric gives each line of text a box of FONT_SIZE_MULT x font size x
// lineHeight and puts the extra space below the line.
const FABRIC_DEFAULT_LINE_HEIGHT = 1.16;
const FABRIC_FONT_SIZE_MULT = 1.13;

// CSS spacing for a text object drawn `fontSize` pixels high. The line
// height is always set: otherwise text inherits the page's 1.5 and sits
// lower, with lines further apart, than in the editor.
export const getTextSpacing = (object: any, fontSize: number) => {
  const lineHeight = object.lineHeight ?? FABRIC_DEFAULT_LINE_HEIGHT;
  const cssLineHeight = Number((FABRIC_FONT_SIZE_MULT * lineHeight).toFixed(4));
  return {
    lineHeight: String(cssLineHeight),
    // CSS splits the extra space above and below each line, so the text
    // moves up by the part CSS adds above the first line.
    offsetY: ((cssLineHeight - FABRIC_FONT_SIZE_MULT) / 2) * fontSize,
    letterSpacing: object.charSpacing ? `${object.charSpacing / 1000}em` : '',
  };
};
